import React, { useContext, useState } from "react";
import { TipKey, TipVariant, useTippy } from "@bloomberg/tippy";

import ErrorBoundary from "~components/ErrorBoundary";
import LedeImage from "~components/Lede/LedeImage";
import LedeVideo from "~components/Lede/LedeVideo";
import Share from "~components/Share";
import { Image, Video } from "~types/types";
import { CurrentStoryContext } from "~utils/currentStoryContext";

import styles from "./styles.module.css";

export default function BasicLede(): JSX.Element {
    const { story } = useContext(CurrentStoryContext);
    const { lede, sites } = story;
    const [giftArticleElement, setGiftArticleElement] =
        useState<Element | null>(null);

    useTippy({
        tipKey: TipKey.GIFT_ARTICLE,
        variant: TipVariant.POPOVER,
        refNode: giftArticleElement,
        additionalSelectorPath: "[data-component=outlined-button]",
    });

    return (
        <div className={styles.ledeContainer}>
            <div className={styles.shareBookmarkMobile}>
                <Share
                    className={styles.shareMobile}
                    hideGiftArticleText
                    giftArticleRef={setGiftArticleElement}
                />
            </div>
            {lede && (
                <div className={styles.ledeContent}>
                    {lede?.type === "image" && (
                        <LedeImage lede={lede as Image} isExpandable />
                    )}

                    {lede?.type === "video" && (
                        <ErrorBoundary fallback="Fail to render Lede Video">
                            <LedeVideo lede={lede as Video} sites={sites} />
                        </ErrorBoundary>
                    )}
                </div>
            )}
        </div>
    );
}
